import { render } from "./meta3.vue?vue&type=template&id=6c0afb36&scoped=true"
import script from "./meta3.vue?vue&type=script&lang=js"
export * from "./meta3.vue?vue&type=script&lang=js"

import "./meta3.vue?vue&type=style&index=0&id=6c0afb36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0afb36"]])

export default __exports__